module.exports = __webpack_public_path__ + "static/media/team-impulse-hype.d39a7684.mp4";